import {FC} from 'react';
import FormAddQuestion from '../FormAddQuestion';

interface IProps {
  id?: string;
  handleChangeQuestion?: () => void;
}
const FormEditQuestion: FC<IProps> = ({id, handleChangeQuestion}) => {
  return <FormAddQuestion ID={id} editQuestion={handleChangeQuestion} />;
};
export default FormEditQuestion;
